module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo4-7a19384729d083cb56f8e5c66594743a.jpg";